import './list/list';
import './list/list-accommodation';
import './list/list-featured';
import './list/list-travel';
import './list/list-favorites';